<template>
  <div class="page--pimple-pop finish bbb-pages">
    <template v-if="isVnSource">
      <div class="header">
        <div class="wrapper">
          <a href="" class="close-button" @click.prevent="backHome()"
            ><img src="/static/img/pimple-pop/close-button@2x.png" width="86"
          /></a>
        </div>
      </div>
    </template>
    <div class="bbb-finish">
      <div v-if="isVnSource" class="score" :class="{ 'score-vn': isVnSource }">
        BẠN ĐƯỢC
        <span>{{ zits }}</span>
        ĐIỂM
      </div>
      <div v-else class="score">
        YOU GET
        <span>{{ zits }}</span>
        <span>{{ zits }}</span>
        POINTS
      </div>
      <template v-if="isVnSource">
        <div v-if="voucherCopywriting && allowed" class="box-congrats" :class="{ 'box-congrats-vn': isVnSource }">
          <h2 class="box-congrats__heading vn">CHÚC MỪNG BẠN!</h2>

          <span class="box-congrats__text vn">BẠN NHẬN ĐƯỢC:</span>
          <div class="coupon-vn">
            <span class="coupon__text-reward" v-html="voucherCopywriting"></span>
          </div>

          <a href="" class="button-print-voucher" @contextmenu.prevent @click.prevent="toggleModalVoucher">
            <template v-if="!processing"> NHẬN NGAY! </template>
            <div v-else id="loaderspinwrap" class="loaderspinwrap"><div class="loaderspin"></div></div>
          </a>
        </div>

        <div v-else class="box-congrats failed">
          <h2 class="box-congrats__heading vn">ĐỪNG VỘI BỎ CUỘC BẠN NHÉ VÌ MÃ GIẢM GIÁ VẪN CÒN RẤT NHIỀU!</h2>
          <button class="button-print-voucher" @click="backHome()">QUAY LẠI MÀN HÌNH TRANG CHỦ</button>
        </div>
      </template>
      <template v-else>
        <div v-if="userGetsFreebie && allowed" class="box-congrats">
          <div class="bbb-event-result">Claim your gift to <br />COSRX Beauty Advisor</div>
        </div>

        <div v-else class="box-congrats">
          <div class="bbb-event-result">Sorry, Let's Try Again!</div>
        </div>
        <a href="/cosrx-vending-machine-event/" class="button-print-voucher"> Back to Home Screen </a>
        <div class="scan-footers">
          <img src="/static/img/cosrx-event/cosrx-event-footer.png" alt="Soco Vending Machine" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const moment = require('moment');
import connectionHelper from '@/mixins/connection-helper.js';
import axios from 'axios';
// const JsBarcode = require('jsbarcode');
const Config = require('~/config/default.env').default;
const Cookies = require('js-cookie');
import VendingMachineTracker from '@/mixins/vending-machine-tracker';

export default {
  name: 'PimplePopFinish',
  mixins: [VendingMachineTracker, connectionHelper],
  data() {
    return {
      dispensedProduct: {},
      dataTierA: [],
      dataTierB: [],
      isModalVoucherOpen: false,
      isModalPrintOpen: false,
      stateIsPrinted: false,
      copyNotAllowed: "Oops! It's not a bad day, just try your luck next time.",
      processing: false,
      voucherCode: '',
      voucherEmail: '',
      allowed: true,
      store_id: '',
      store_name: '',
      lowerScoreMode: false,
      timeout: 30 * 1000,
      interval: '',
      idleTimer: null,
    };
  },
  computed: {
    fullname() {
      if (this.$SO.size(this.$store.state.auth.userProfile)) {
        return this.$store.state.auth.userProfile.name;
      } else {
        return '';
      }
    },
    today() {
      if (this.$route.query.isvn) {
        return moment().format('DD/MM/YYYY');
      } else {
        return moment().format('Do MMMM YYYY');
      }
    },
    userGetsFreebie() {
      let userGetsFreebie = false;
      if (this.zits >= 1) {
        userGetsFreebie = true;
      }
      return userGetsFreebie;
    },
    voucherCopywriting() {
      if (this.isVnSource) {
        if (this.zits > (this.lowerScoreMode ? 25 : 80)) {
          return `GIẢM 15% <br/> TỔNG HOÁ ĐƠN`;
        } else if (this.zits >= (this.lowerScoreMode ? 20 : 10) && this.zits <= (this.lowerScoreMode ? 25 : 80)) {
          return `GIẢM 10% <br/> TỔNG HOÁ ĐƠN`;
        } else {
          return false;
        }
      } else {
        if (this.zits >= (this.lowerScoreMode ? 25 : 100)) {
          return `15% OFF STOREWIDE`;
        } else if (this.zits >= (this.lowerScoreMode ? 20 : 50) && this.zits < (this.lowerScoreMode ? 25 : 100)) {
          return `10% OFF STOREWIDE`;
        } else {
          return false;
        }
      }
    },
    VoucherPrintCopyWrite() {
      if (this.zits >= (this.lowerScoreMode ? 25 : 100)) {
        return `15%`;
      } else if (this.zits >= (this.lowerScoreMode ? 20 : 50) && this.zits < (this.lowerScoreMode ? 25 : 100)) {
        return `10%`;
      } else {
        return '-';
      }
    },
    zits() {
      return this.$store.state.pimplePop.zits;
    },
    maximumDisc() {
      // if(this.$route.query.isvn){
      // 	return this.VoucherPrintCopyWrite == '15%' ? 75000 : 50000
      // } else {
      // 	return this.VoucherPrintCopyWrite == '15%' ? 150000 : 100000
      // }
      return this.VoucherPrintCopyWrite == '15%' ? 150000 : 100000;
    },
    isVnSource() {
      return this.$route.query.isvn;
    },
    store_detail() {
      return JSON.parse(Cookies.get('store_detail'));
    },
  },
  mounted() {
    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
    this.startIdleTimer();
    this.addActivityListeners();
    // JsBarcode("#barcode").init();
  },
  beforeDestroy() {
    this.$store.commit('setZits', 0);
    const parent = document.querySelector('html');
    if (parent != undefined) {
      parent.classList.remove('noscroll');
    }
    clearInterval(this.interval);
    this.destroyListener();
    this.clearIdleTimer();
    this.removeActivityListeners();
  },
  created() {
    if (this.zits >= 1) {
      this.fetchSlotDetail();
    } else {
      this.saveLog('N/A', 0, { id: 'N/A', name: 'N/A' });
    }

    // if (document.cookie.indexOf(`pimplePopUser-${this.$store.state.auth.userProfile._id}=1`) > -1) {
    //   this.allowed = false;
    //this.startTimer();
    // }
  },
  methods: {
    // Auto-logout functionality methods
    startIdleTimer() {
      this.clearIdleTimer();
      this.idleTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.timeout);
    },

    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },

    resetIdleTimer() {
      this.startIdleTimer();
    },

    handleAutoLogout() {
      this.$store
        .dispatch('userLogout')
        .then(() => {
          this.$router.push('/cosrx-vending-machine-event/scan-qr');
        })
        .catch(() => {
          this.$router.push('/cosrx-vending-machine-event/scan-qr');
        });
    },

    addActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.addEventListener(event, this.handleUserActivity, true);
      });
    },

    removeActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.removeEventListener(event, this.handleUserActivity, true);
      });
    },

    handleUserActivity() {
      this.resetIdleTimer();
    },
    closeModal() {
      this.isModalPrintOpen = false;
    },
    async saveLog(tier, slot, product) {
      const payloadCreated = {
        user: {
          id: this.$store.state.auth.userProfile.id,
          user_name: this.$store.state.auth.userProfile.user_name,
        },
        time_started_at: this.$store.state.pimplePop.start_time,
        screen: 'COSRX Vending Machine Games',
        score: this.zits,
        store: {
          id: this.store_detail.store_id,
          name: this.store_detail.name,
        },
        is_product_dispensed: tier !== 'N/A',
        tier: tier,
        product: product && Object.keys(product).length > 0 ? product : { name: 'N/A', id: 'N/A' },
        slot: slot,
      };
      await axios.post(`${Config.MS_SOCIOLLA_PUBLIC_API_URL}/vending-machine/logs`, payloadCreated).then((res) => {
        console.log(res);
      });
    },
    async dispensePrize(tier, slot, product) {
      const headers = {
        'SOC-PLATFORM': 'vending-machine',
        store_id: this.store_detail.store_id,
      };
      await axios
        .get(
          `http://localhost:1945/trigger/${slot}`,
          {
            products: product,
          },
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status && res.status != 200) {
            console.log(res);
          }
        })
        .catch((err) => {
          // need to check response from machine
          console.error(err);
        })
        .finally(() => {
          this.saveLog(tier, slot, product);
        });
    },
    async fetchSlotDetail() {
      const vendingMachineId = this.store_detail._id;
      const storeId = this.store_detail.store_id;
      await axios
        .post(`${Config.MS_CATALOG_API_URL}/vending-machines/${vendingMachineId}/dispense`, {
          score: Number.parseInt(this.zits),
          storeId: storeId,
        })
        .then((res) => {
          if (res.data.success) {
            this.dispensePrize(res.data.data.tier, res.data.data.slot, res.data.data.product);
          }
        });
    },
    openModal() {
      this.isModalPrintOpen = true;
      setTimeout(() => {
        window.print();
        this.stateIsPrinted = true;
      }, 2000);
    },
    toggleModalVoucher() {
      this.isModalVoucherOpen = !this.isModalVoucherOpen;
      const parent = document.querySelector('html');
      if (this.isModalVoucherOpen == true) {
        if (parent != undefined) {
          parent.classList.add('noscroll');
        }
      } else {
        if (parent != undefined) {
          parent.classList.remove('noscroll');
        }
      }
    },
    async backHome() {
      try {
        this.$router.push('/cosrx-vending-machine-event/');
      } catch (err) {
        console.log(err);
        this.$router.push('/cosrx-vending-machine-event/');
      }
    },
    limitUser() {
      if (!this.$store.state.auth.userProfile) {
        return false;
      }

      const m = moment();
      // sociolla-admin expects date in utc > 23:59:29(id)== 16:59:59(utc)
      const endDateDay = new Date(m.get('year'), m.get('month'), m.get('date'), 16, 59, 59);
      const cookiename = `pimplePopUser-${this.$store.state.auth.userProfile._id}=1`;

      if (document.cookie.indexOf(cookiename) < 0) {
        document.cookie = `${cookiename}; expires=${endDateDay}`;
      }
    },
    startTimer() {
      this.interval = setInterval(() => {
        this.$router.push('/cosrx-vending-machine-event/');
        clearInterval(this.interval);
      }, this.timeout);
    },
  },
};
</script>

<style lang="scss" scoped>
.bbb-finish {
  min-height: 100vh;
  background: #000 url('/static/img/cosrx-event/cosrx-game-finish.png') no-repeat top center;
  background-size: 100% auto;
  padding: 150px 0 0;
  box-sizing: border-box;
}
.title {
  display: block;
  margin: 0 auto 146px;
}
.title-vn {
  margin: 0 auto 126px;
}
.score-vn {
  margin: 0 auto 40px !important;
  font-family: 'Pretendard', sans-serif !important;
}
.score {
  position: relative;
  display: inline-block;
  top: 258px;
  gap: 148px;
  width: 400px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font: normal 42px/42px 'Pretendard', sans-serif;
  font-weight: 700;
  margin: 0 auto 60px;
  position: relative;
  z-index: 1;
}

.score span {
  font: normal 120px/32px 'Pretendard', sans-serif;
  font-weight: 700;
  display: block;
  width: 100%;
  text-align: center;
  margin: 42px 0;
  position: absolute;
  top: 140px;
  left: 0;
}

.score span:first-child {
  color: #000;
  z-index: 1;
}

.score span:nth-child(2) {
  color: #fff;
  z-index: 2;
  transform: translate(-6px, -6px); /* Offset to create shadow */
}

.scan-footers {
  background-color: transparent !important;
  padding: 0 !important;
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
}

.bbb-event-result {
  position: relative;
  font-size: 40px;
  font-family: 'Pretendard';
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  bottom: 445px;
}
.bbb-collect-freebies {
  padding: 70px;
}
.bbb-pages {
  .box-congrats {
    background: transparent;
    height: auto;
    padding: 0;
    position: absolute;
    top: 68%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .button-print-voucher {
    background: #6cebfb;
    position: fixed;
    bottom: 310px;
    left: 50%;
    width: 45%;
    transform: translateX(-50%);
    color: black;
    padding: 15px 30px;
    border-radius: 48px;
    text-align: center;
    z-index: 1000;
    font-family: 'Pretendard';
    font-weight: 700;
    font-size: 28px;
    border: 3px solid black;
  }
  .box-congrats__heading {
    color: #eb395f;
  }
  .box-congrats__text {
    color: #fff;
  }
  .coupon {
    padding-top: 37px;
    background: transparent url('/static/img/big-bang-boom/voucher-bbb-store.png') no-repeat center;
    background-size: cover;
  }
  .coupon-vn {
    width: 638px;
    height: 215px;
    padding-top: 37px;
    background: transparent url('/static/img/big-bang-boom/coupon-bbb-vn.png') no-repeat center;
    background-size: cover;
    margin: 0 auto 61px auto;
    padding: 43px 73px 43px 128px;
  }
  .coupon__text-reward {
    color: #fff;
  }
}
.vn {
  font-family: 'Pretendard', sans-serif !important;
}

@media print {
  .title,
  .score {
    display: none;
  }
}

@media screen and (max-width: 950px) and (min-width: 900px) {
  .score {
    top: 178px;
  }
  .bbb-event-result {
    bottom: 390px;
  }
  .bbb-pages .button-print-voucher {
    bottom: 272px;
    height: 4.5%;
  }
  .scan-footers {
    transform: scale(0.86);
    bottom: -20px;
    left: -64px;
  }
  .page--pimple-pop {
    min-height: 1652px;
  }
}
</style>
